import Vue from 'vue'
import Vuex, {ActionContext} from 'vuex'
import axios from "axios";
import gorevYoneticisi from "@/plugins/uyap-plugin/store/modules/GorevYoneticisi";
import {AppState, AppStatus, ITenant, ManifestResponse, UyapStatusMessage} from '@/types';
import VueSocketIOExt from 'vue-socket.io-extended';
import {io} from 'socket.io-client';
import app from "@/main";
import {UYAP_PLATFORM_SOCKET} from "@/plugins/uyap-plugin/imza";
import {KullaniciBilgileriCevap} from "@/plugins/uyap-plugin/uyap/KullaniciBilgileri";
import {promptForMobilImzaCredentials} from "@/plugins/uyap-plugin/utils/mobil-imza-credentials-modal";
import _Vue from "vue";

const socket = io('https://imza.eicrapro.com:3000');
Vue.use(VueSocketIOExt, socket);
Vue.use(Vuex);

export const store = new Vuex.Store<AppState>({
    modules: {
        // @ts-ignore
        gorevYoneticisi
    },
    state: {
        uyapConnection: false,
        appStatus: AppStatus.loading,
        tenant: undefined,
        manifestResponse: {files: []},
        availableCardList: [],
        selectedCardSerial: null,
        tokenExis: false,
        devMode: true,
        eicraproDevMode: false,  // Mock data kullanmak için true yap
        uyapAvukatBilgileri: undefined,
        uyapAvukatBakiye: undefined,
        uyapSorguBakiye: undefined,
        uyapStatusMessage: null,
        connectionHealthCheckInterval: null as number | null,
        healthCheckRetryCount: 0,
        healthCheckMaxRetries: 3
    },
    getters: {
        appStatus: (state) => state.appStatus,
        isLoading: (state) => state.appStatus === AppStatus.loading,
        isUpdate: (state) => state.appStatus === AppStatus.update,
        isBrowser: (state) => state.appStatus === AppStatus.browser,
        isElectron: (state) => state.appStatus === AppStatus.electron,
        isUyapConnected: (state) => state.uyapConnection,
        isTokenExis: (state) => state.tokenExis,
        isDevMode: (state) => state.devMode,
        isEicraproDevMode: (state) => state.eicraproDevMode,
        uyapAvukatBilgileri: (state) => state.uyapAvukatBilgileri,
        uyapAvukatBakiye: (state) => state.uyapAvukatBakiye,
        uyapSorguBakiye: (state) => state.uyapSorguBakiye,
        availableCardList: (state) => state.availableCardList,
        selectedCardSerial: (state) => state.selectedCardSerial,
        tenantBilgileri: (state) => state.tenant,
        uyapStatusMessage: (state) => state.uyapStatusMessage,
        healthCheckRetryCount: (state) => state.healthCheckRetryCount,
        isHealthChecking: (state) => state.connectionHealthCheckInterval !== null
    },
    mutations: {
        setAppState(state: AppState, value: AppStatus): void {
            state.appStatus = value;
        },
        setManifestResponse(state: AppState, response: ManifestResponse) {
            state.manifestResponse = response;
        },
        setAvailableCardList(state: AppState, value: any) {
            state.availableCardList = value;
        },
        setSelectedCardSerial(state: AppState, serial: string | null) {
            state.selectedCardSerial = serial;
        },
        setUyapConnection(state: AppState, payload: boolean) {
            app.$socket.client.emit("uyapconnection", {
                connected: payload,
                JSESSIONID: payload ? sessionStorage.getItem('JSESSIONID') : ''
            });
            state.uyapConnection = payload;
        },
        setUyapAvukatBilgileri(state: AppState, avukat: KullaniciBilgileriCevap | undefined) {
            state.uyapAvukatBilgileri = avukat;
        },
        setUyapAvukatBakiye(state: AppState, payload: string | undefined) {
            state.uyapAvukatBakiye = payload;
        },
        setUyapSorguBakiye(state: AppState, payload: string | undefined) {
            state.uyapSorguBakiye = payload;
        },
        setTenant(state: AppState, tenant: ITenant) {
            state.tenant = tenant;
        },
        setUyapStatusMessage(state: AppState, payload: UyapStatusMessage | null) {
            state.uyapStatusMessage = payload;
        },
        setHealthCheckInterval(state: AppState, interval: any) {
            state.connectionHealthCheckInterval = interval;
        },
        setHealthCheckRetryCount(state: AppState, count: number) {
            state.healthCheckRetryCount = count;
        },
    },
    actions: {
        async connectToUyap(ctx: ActionContext<AppState, AppState>) {
            try{
                console.log("connectToUyap TRIGGERED !!!!");
                let loginType = window.localStorage.getItem("loginType");
                if(loginType == "mobil-imza")
                    await ctx.dispatch("mobilImzaLogin");
                else
                    await app.$imza.betaLogin();
                await ctx.dispatch('loadUyapMetaData');
                ctx.commit('setUyapConnection', true);
                ctx.commit('setUyapStatusMessage', {
                    type: 'success',
                    text: 'Uyap bağlantısı tamamlandı.',
                    timestamp: Date.now()
                });
                //app.$toast.success('Uyap bağlantısı tamamlandı.');
            }catch (error) {
                ctx.commit('setUyapConnection', false);
                const message = `Uyap bağlantısı yapılamadı. (${String(error)})`;
                ctx.commit('setUyapStatusMessage', {
                    type: 'error',
                    text: message,
                    timestamp: Date.now()
                });
                throw new Error(String(error));
            }

        },

        async setEdevletCookiesToImza(): Promise<void>{
            let cookiesStr = window.sessionStorage.getItem("edevlet-cookies");
            if(cookiesStr){
                const cookies = cookiesStr
                    .split(';')
                    .map(c => c.trim())
                    .filter(Boolean);
                console.log("cookies array", cookies);
                await axios.post(
                    "https://imza.eicrapro.com:6081/cookie",
                    { cookies: cookies },
                    { withCredentials: true }
                );
            }
        },

       async mobilImzaLogin(ctx: ActionContext<AppState, AppState>): Promise<void> {
            try{
                await ctx.dispatch("setEdevletCookiesToImza");
                //Oturum varsa tekrar login olmasina gerek yok...
                let kullaniciBilgileri = await app.$uyap.KullaniciBilgileri().run({});
                console.log("mobilImzaLogin kullaniciBilgileri geldi !!!",kullaniciBilgileri);
                return ;
            }catch (e) {
                console.log("ERROR mobilImzaLogin",e);
                //console.log("Oturum YOK TEKRAR OTURUM AÇMA İSTEĞİYLE DEVAM EDİLECEK.");
                _Vue.prototype.$socket.client.emit("imzaMessage",{
                    title: "Mobil imza oturumu bulunamadı ! Lütfen çıkış yapıp tekrar giriş yapınız.",
                    text:  e.message,
                    icon: "error",
                    logout: true,
                    allowOutsideClick: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Tamam'
                });

                throw new Error("Mobil Imza Oturumu Bulunamadı !");
            }
            //let credentials = window.localStorage.getItem("credentials");
            //if(credentials){
            //    credentials = JSON.parse(credentials);
            //}else {
             //   const formData = await promptForMobilImzaCredentials();
             //   if (!formData) {
             //       throw new Error('Mobil imza girişi iptal edildi.');
              //  }
              //  credentials = formData;
              //  window.localStorage.setItem("credentials", credentials);
            //}
            //await app.$imza.eDevletMobilImzaLogin(credentials);
            //await ctx.dispatch("setEdevletCookiesToImza");
        },

        async loadUyapMetaData(ctx: ActionContext<AppState, AppState>): Promise<void> {
            const [bakiyeResult, sorguBakiyeResult, kullaniciResult] = await Promise.allSettled([
                app.$uyap.AvukatBakiyeSorgula().run({}),
                app.$uyap.SorguBakiyesi().run({}),
                app.$uyap.KullaniciBilgileri().run({})
            ]);

            if (bakiyeResult.status === "fulfilled") {
                ctx.commit('setUyapAvukatBakiye', (bakiyeResult.value as { value: string }).value);
            } else {
                ctx.commit('setUyapAvukatBakiye', undefined);
                console.error('AvukatBakiyeSorgula failed', bakiyeResult.reason);
            }

            if (sorguBakiyeResult.status === "fulfilled") {
                const sorguBakiye = (sorguBakiyeResult.value as { sorguBakiye: number }).sorguBakiye;
                ctx.commit('setUyapSorguBakiye', String(sorguBakiye));
            } else {
                ctx.commit('setUyapSorguBakiye', undefined);
                console.error('SorguBakiyesi failed', sorguBakiyeResult.reason);
            }

            if (kullaniciResult.status === "fulfilled") {
                ctx.commit('setUyapAvukatBilgileri', kullaniciResult.value as KullaniciBilgileriCevap);
            } else {
                ctx.commit('setUyapAvukatBilgileri', undefined);
                console.error('KullaniciBilgileri failed', kullaniciResult.reason);
            }

            app.$socket.client.emit("uyapAvukatBilgileri", {
                uyapAvukatBilgileri: ctx.state.uyapAvukatBilgileri,
                uyapAvukatBakiye: ctx.state.uyapAvukatBakiye,
                uyapSorguBakiye: ctx.state.uyapSorguBakiye
            });
        },
        async availableCards(ctx: ActionContext<AppState, AppState>, payload?: { silent?: boolean }) {
            console.log("availableCards triggered");
            const silent = Boolean(payload?.silent);
            try{
                let data = await app.$imza.availableCards();
                //console.log("data availableCards",data);
                ctx.commit('setAvailableCardList', data);
                if (Array.isArray(data) && data.length > 0) {
                    const current = ctx.state.selectedCardSerial;
                    const match = data.find((card: any) => card?.cardOwner?.serialNumber === current);
                    const fallbackSerial = data[0]?.cardOwner?.serialNumber ?? null;
                    ctx.commit('setSelectedCardSerial', match ? current : fallbackSerial);
                    const currentMessage = ctx.state.uyapStatusMessage?.text?.toLowerCase() ?? '';
                    if (currentMessage.includes('kart') || currentMessage.includes('imzacı')) {
                        ctx.commit('setUyapStatusMessage', null);
                    }
                } else {
                    ctx.commit('setSelectedCardSerial', null);
                }
                if (!silent) {
                    //app.$toast.success('Kart listesi alındı');
                }
            }catch (e) {
                console.log("CATCH E",e);
                const errMsg = e instanceof Error ? e.message : String(e);
                ctx.commit('setAvailableCardList', []);
                ctx.commit('setSelectedCardSerial', null);
                ctx.commit('setUyapStatusMessage', {
                    type: 'error',
                    text: errMsg,
                    timestamp: Date.now()
                });
                if (!silent) {
                    app.$toast.error(errMsg);
                }
            }
        },
        selectSmartCard(ctx: ActionContext<AppState, AppState>, serial: string | null) {
            ctx.commit('setSelectedCardSerial', serial);
        },
        openUyapWindow() {
            window.open('https://avukatbeta.uyap.gov.tr/', "_blank");
        },
        async fastLoginUyap(ctx: ActionContext<AppState, AppState>) {
            try {
                let avukat = await app.$uyap.KullaniciBilgileri().run({});
                ctx.commit('setUyapConnection', true);
                ctx.commit('setUyapAvukatBilgileri', avukat);
                await ctx.dispatch('loadUyapMetaData');
            } catch (e) {
                await ctx.dispatch('connectToUyap');
            }
        },
        async checkUyapSessionNew(ctx: ActionContext<AppState, AppState>) {
            console.log("checkUyapSessionNew triggered");
            try {
                await ctx.dispatch('loadUyapMetaData');
                //await app.$uyap.KullaniciBilgileri().run({});
                ctx.commit('setUyapConnection', true);
            } catch (error) {
                ctx.commit('setUyapConnection', false);
            }
        },
        async checkUyapSession(ctx: ActionContext<AppState, AppState>) {
            console.log("checkUyapSession triggered");
            try {
                if (ctx.getters.isEicraproDevMode) {
                    ctx.commit('setUyapConnection', true);
                } else {
                    await app.$imza.setCookieToImza();
                    await ctx.dispatch("fastLoginUyap");
                    ctx.commit('setUyapStatusMessage', {
                        type: 'success',
                        text: 'Uyap oturumu doğrulandı.',
                        timestamp: Date.now()
                    });
                }
            } catch (error) {
                ctx.commit('setUyapConnection', false);
                const message = `Uyap oturumu doğrulanamadı. ${String(error ?? '')}`.trim();
                ctx.commit('setUyapStatusMessage', {
                    type: 'error',
                    text: message,
                    timestamp: Date.now()
                });
            }
        },
        async setTasksSocket(ctx: ActionContext<AppState, AppState>) {
            // context.di/getTasksFromServer
            await ctx.dispatch("getTasksFromServer")
            app.$socket.client.emit("tasks", ctx.getters.getGorevler);
        },
        async load(ctx: ActionContext<AppState, AppState>): Promise<void> {
            ctx.commit("setAppState", AppStatus.loading);
            if (sessionStorage.getItem('accessToken'))
                ctx.state.tokenExis = true;
            if (!window.zirvelib) {
                return ctx.commit('setAppState', AppStatus.browser);
            } else {
                const updateRequires = !await ctx.dispatch('isLocalUpToDate');
                console.log("updateRequires", updateRequires);
                if (updateRequires) {
                    return ctx.commit('setAppState', AppStatus.update);
                }
                try {
                    if (!await ctx.dispatch('checkSignService')) {
                        await ctx.dispatch('startSignService');
                    }
                    if (!await ctx.dispatch('checkProxyService')) {
                        await ctx.dispatch('startProxyService');
                    }
                    return ctx.commit('setAppState', AppStatus.electron);
                } catch (e) {
                    console.log(e);
                    return ctx.commit('setAppState', AppStatus.error);
                }
            }
        },
        async isLocalUpToDate(): Promise<boolean> {
            return new Promise((resolve) => {
                if (!window.zirvelib) {
                    return resolve(false);
                }
                if (!window.zirvelib?.version) {
                    return resolve(false);
                }
                console.log("window.zirvelib.version", window.zirvelib.version);
                return resolve(
                    window.zirvelib.version === "1.3.0"
                );
            });
        },

        async checkSignService(): Promise<boolean> {
            return new Promise((resolve, reject) => {
                if (!window.zirvelib) {
                    return reject('zirvelib not found');
                }
                const heartbeatPromise = axios.post('http://127.0.0.1:4723/xml/heartbeat', {});
                heartbeatPromise.then(() => {
                    console.log('Sign service is running');
                    resolve(true);
                }).catch((error) => {
                    console.warn('Sign service check failed:', error.message);
                    resolve(false);
                });
            })
        },
        async checkProxyService(): Promise<boolean> {
            return new Promise((resolve) => {
                const heartbeatPromise = axios.post('https://imza.eicrapro.com:6090/xml/heartbeat', {});
                heartbeatPromise.then(() => {
                    console.log('Proxy service is running');
                    resolve(true);
                }).catch((error) => {
                    console.warn('Proxy service check failed:', error.message);
                    resolve(false);
                });
            });
        },
        async startSignService(): Promise<void> {
            console.log("Starting Sign Service");
            return new Promise((resolve, reject) => {
                if (!window.zirvelib) {
                    return reject('zirvelib not found');
                }
                window.zirvelib.signManager.start();
                window.setTimeout(() => {
                    resolve();
                }, 2000)
            })
        },

        async startProxyService(ctx: ActionContext<AppState, AppState>): Promise<void> {
            return new Promise((resolve, reject) => {
                if (!window.zirvelib) {
                    return reject('zirvelib not found');
                }
                window.zirvelib.proxyManager.start();
                window.zirvelib.socketManager.start();
                window.setTimeout(() => {
                    resolve();
                }, 2000)
            });
        },

        async stopSignService(): Promise<void> {
            return new Promise((resolve, reject) => {
                if (!window.zirvelib) {
                    return reject('zirvelib not found');
                }
                window.zirvelib.signManager.kill();
                window.setTimeout(() => {
                    resolve();
                }, 1500)
            })
        },
        async stopProxyService(): Promise<void> {
            return new Promise((resolve, reject) => {
                if (!window.zirvelib) {
                    return reject('zirvelib not found');
                }
                window.zirvelib.proxyManager.stop();
                window.zirvelib.socketManager.stop();
                resolve();
            })
        },
        async checkHeartbeat(ctx: ActionContext<AppState, AppState>): Promise<boolean> {
            try {
                const response = await fetch('https://imza.eicrapro.com:6090/xml/heartbeat', {
                    method: 'POST',
                    credentials: 'include'
                });

                if (response.ok) {
                    ctx.commit('setHealthCheckRetryCount', 0);
                    return true;
                } else {
                    // Heartbeat başarısız, reconnect dene
                    ctx.commit('setHealthCheckRetryCount', (ctx.state.healthCheckRetryCount || 0) + 1);
                    if (ctx.state.healthCheckRetryCount < ctx.state.healthCheckMaxRetries) {
                        console.log(`Heartbeat başarısız, reconnect deneniyor (${ctx.state.healthCheckRetryCount}/${ctx.state.healthCheckMaxRetries})`);
                        await ctx.dispatch('connectToUyap');
                    } else {
                        ctx.commit('setUyapStatusMessage', {
                            type: 'error',
                            text: `Heartbeat başarısız. ${ctx.state.healthCheckMaxRetries} deneme tamamlandı.`,
                            timestamp: Date.now()
                        });
                        console.error('Heartbeat max retry ulaştı');
                    }
                    return false;
                }
            } catch (error) {
                ctx.commit('setHealthCheckRetryCount', (ctx.state.healthCheckRetryCount || 0) + 1);
                console.error('Heartbeat hatası:', error);

                if (ctx.state.healthCheckRetryCount < ctx.state.healthCheckMaxRetries) {
                    console.log(`Heartbeat hatası, reconnect deneniyor (${ctx.state.healthCheckRetryCount}/${ctx.state.healthCheckMaxRetries})`);
                    await ctx.dispatch('connectToUyap');
                }
                return false;
            }
        },
        startHealthCheck(ctx: ActionContext<AppState, AppState>) {
            // Zaten çalışıyorsa tekrar başlatma
            if (ctx.state.connectionHealthCheckInterval !== null) {
                console.log('Health check zaten çalışıyor');
                return;
            }

            console.log('Health check başlatıldı');
            const interval = setInterval(async () => {
                if (ctx.getters.isUyapConnected) {
                    await ctx.dispatch('checkHeartbeat');
                }
            }, 5000); // Her 5 saniyede bir kontrol et

            ctx.commit('setHealthCheckInterval', interval);
        },
        stopHealthCheck(ctx: ActionContext<AppState, AppState>) {
            if (ctx.state.connectionHealthCheckInterval !== null) {
                clearInterval(ctx.state.connectionHealthCheckInterval);
                ctx.commit('setHealthCheckInterval', null);
                ctx.commit('setHealthCheckRetryCount', 0);
                console.log('Health check durduruldu');
            }
        },
    }
})
